import React, { useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./style.css"; // Import the CSS file for styling
import { Link } from "react-router-dom";

const faqs = [
	{
    	question: "Who is Dr (Major) Rajesh Bhardwaj ?",
    	answer: "Dr (Major) Rajesh Bhardwaj is a very senior ENT Specialist practising in Vasant Vihar, New Delhi since 1997 - He is a graduate and Post Graduate from the prestigious Armed Forces Medical College, Pune and an Ex Army person. He brings all the ethics, discipline and integrity of the Armed Forces into his practice.",
  	},
  	{
    	question: "Where is Dr. (Major) Rajesh Bhardwaj's clinic located?",
    	answer: "Dr Bhardwaj practices at the MedFirst ENT Centre located in the pristine surroundings of Vasant Vihar in New Delhi. Located opposite the Shri Ram School his clinic adjoins a National Reserved Forest. Many patients and their attendants take a leisurely walk along the Forest track during their visit to the Clinic.",
  	},
  	{
    	question: "Does Dr. (Major) Rajesh Bhardwaj perform surgeries?",
    	answer: "Dr Bhardwaj is very well trained – he is a post graduate by doing his DLO from Nagpur, MS (ENT) from AFMC, Pune and is also a Diplomate of the National Board (DNB, ENT). He attends regular surgical workshops to hone his surgical skills as well as to learn new skills and new techniques. He uses the latest techniques and technologies in performing ENT Surgeries.",
  	},
  	{
    	question: "How can I schedule an appointment with Dr. (Major) Rajesh Bhardwaj?",
    	answer: <>You can schedule an appointment with Dr. (Major) Rajesh Bhardwaj at MedFirst ENT Centre, Vasant Vihar, New Delhi. Appointments can be booked by calling the clinic directly, through our website (<Link to="https://entdelhi.com">entdelhi.com</Link>), Google Business Profile (GMB), Practo, or by visiting the clinic in person. It is recommended to book in advance to minimize waiting time.</>,
  	},
	{
    	question: "Does Dr. (Major) Rajesh Bhardwaj offer teleconsultations or online consultations?",
    	answer: <>Yes, Dr. (Major) Rajesh Bhardwaj offers online and teleconsultations for patients who are unable to visit the clinic in person. You can easily book a virtual consultation through our website (<Link to="https://entdelhi.com">entdelhi.com</Link>), Google Business Profile (GMB), or Practo, and receive expert guidance from the comfort of your home.</>,
  	}
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
    <section className="faq py-5 my-5">
        <div className="container">
          <div className="row">
            <div className="pq-section pq-style-1 text-center">
              <span className="pq-section-sub-title">FAQ</span>
              <h2 className="pq-section-title">Frequently Asked Question</h2>
            </div>

            <div className="col-xl-12 mt-xl-0 mt-5 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {faqs.map((faq, index) => (
                  <div
                    className={`pq-accordion-box ${
                      activeIndex === index ? "active" : ""
                    }`}
                    key={index}
                  >
                    <div
                      className="pq-ad-title"
                      onClick={() => toggleAccordion(index)}
                    >
                      <h4 className="ad-title-text">
                        {faq.question}
                        <i
                          className={`fa ${
                            activeIndex === index
                              ? "fa-chevron-up"
                              : "fa-chevron-down"
                          }`}
                        ></i>
                      </h4>
                    </div>
                    <div
                      className={`pq-accordion-details ${
                        activeIndex === index ? "open" : ""
                      }`}
                    >
                      <p className="pq-detail-text">{faq.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;